import { createContext } from 'react';

const AppPagesContext = createContext(null);

export { AppPagesContext };
